import {
  CORE_LOAD_ALL_EVENT_ROOM_SERVICE_REQUEST,
  CORE_LOAD_ALL_EVENT_ROOM_SERVICE_SUCCESS,

  CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_REQUEST,
  CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_SUCCESS,
} from '../../types'

export default {
  eventService: (state = {}, action = {}) => {
    switch (action.type) {
      case CORE_LOAD_ALL_EVENT_ROOM_SERVICE_REQUEST:
        return state
      case CORE_LOAD_ALL_EVENT_ROOM_SERVICE_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  eventMonthService: (state = [], action = {}) => {
    switch (action.type) {
      case CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_REQUEST:
        return state
      case CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_SUCCESS:
        return action.payload
      default:
        return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/front/features/roomService/reducer.js